import { useQuery } from '@tanstack/react-query';
import type { OptimisationCompareDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface OptimisationCompareApiResponse {
  success: boolean;
  data: OptimisationCompareDto;
}

export function useOptimisationCompare(
  runAId: number | undefined,
  runBId: number | undefined,
) {
  return useQuery({
    queryKey: ['optimisation', 'compare', runAId, runBId],
    queryFn: async () => {
      const response = await apiClient.get<OptimisationCompareApiResponse>(
        `/optimisation/runs/${runAId}/compare/${runBId}`,
      );
      return response.data.data;
    },
    enabled: runAId != null && runAId > 0 && runBId != null && runBId > 0,
  });
}
